import styled from 'styled-components';

export const NameStyles = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
`;

export const NameOfType = styled.span`
  font-size: ${({ theme }) => theme.fontSize.nm};
  color: ${({ theme }) => theme.colors.color_darkgray};
  font-weight: normal;
  text-transform: capitalize;
`;

export const NameLink = styled.a`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.limedSpruce};
  font-weight: bold;

  &.tablet {
    font-size: ${({ theme }) => theme.fontSize.nm};
  }

  .text {
    margin-right: 6px;
  }

  .priority-icon {
    margin-right: 12px;
  }
`;
